import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

export function productVendorsQueryOptions(q: string) {
  return queryOptions({
    queryKey: productKeys.vendorSearch(q),
    queryFn: () => productsApi.vendors(q),
    staleTime: 60_000,
  });
}

/** Vendors matching `q`, fetched only while the picker is open; keeps the last list while typing. */
export function useProductVendors(q: string, enabled: boolean) {
  return useQuery({ ...productVendorsQueryOptions(q), enabled, placeholderData: keepPreviousData });
}
